import { render, staticRenderFns } from "./ExternalNotesLevel.vue?vue&type=template&id=be7f4a56"
import script from "./ExternalNotesLevel.vue?vue&type=script&lang=js"
export * from "./ExternalNotesLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports